'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
const {
  app
} = window;
var _default = exports.default = /*#__PURE__*/_react.default.forwardRef(function Link(props, ref) {
  const is_link = props.href ? true : false;
  let output;
  if (is_link && props.href !== document.location.pathname) {
    let href = (props.href || '/').startsWith('/') === false ? '/404' : props.href;
    output = /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, (0, _extends2.default)({
      className: props.className,
      ref: ref
    }, props, {
      to: href,
      onClick: handleClick
    }), props.children);
  } else {
    output = /*#__PURE__*/_react.default.createElement("span", (0, _extends2.default)({
      className: props.className
    }, props, {
      ref: ref
    }), props.children);
  }
  return output;
  function handleClick(e) {
    app.resetFunctions();
    if ((props.href || '/').startsWith('/') === false) {
      window.localStorage.setItem('requested_PAGE_CODE', props.href);
    }
  }
});
